import { gu_isAppLayoutProMax } from '@utils/general-util';

import { prepareSp4SurfaceRollout } from './sp4-bridge/surface-rollout-startup';

const layouts = import.meta.glob('./index-layout-*.js'); // lazy by default

// Get current domain (hostname only, without protocol/path)
const domain = window.location.hostname;
const toBool = (v) => v === true || v === 'true';

let key;
if (!window.isAffiliate && gu_isAppLayoutProMax()) {
    // temporarily hardcode beta first.
    key = './index-layout-pro-max.js';
} else if (!window.isAffiliate && (toBool(window.appLayoutLite) || (Array.isArray(window.appLayoutLite) && window.appLayoutLite.includes(domain)))) {
    key = './index-layout-lite.js';
} else if (toBool(window.appLayoutPro) && !window.isAffiliate) {
    key = './index-layout-pro.js';
} else {
    key = './index-layout-1.js';
}

const initLayout = () => layouts[key]().then((m) => m.init?.());

prepareSp4SurfaceRollout(key === './index-layout-pro.js', initLayout);

// LOCAL DEV MODE
if (import.meta.env.DEV) {
    fetch(`/public/html/settings/design-tokens.json`)
        .then((response) => {
            if (!response.ok) throw new Error(`Token file not found`);
            return response.json();
        })
        .then((tokens) => {
            const cssVariables = Object.entries(tokens)
                .map(([key, value]) => `${key}: ${value};`)
                .join('\n');

            const styleString = `:root {\n${cssVariables}\n}`;

            const styleTag = document.getElementById('ssi_design_tokens');
            if (styleTag) {
                styleTag.innerHTML = styleString;
                console.log(`⚡ Loaded design-tokens`);
            }
        })
        .catch((err) => console.error('❌ Error loading design tokens:', err));
}
